import React from 'react';
import { Button } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

interface LogoutButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

/**
 * Logout button component that handles Auth0 logout
 * Only renders when user is authenticated and auth is enabled
 */
export const LogoutButton: React.FC<LogoutButtonProps> = ({
  variant = 'outlined',
  size = 'medium',
  fullWidth = false,
}) => {
  const { logout, isAuthenticated } = useAuth();
  const isAuthEnabled = import.meta.env.VITE_AUTH_ENABLED === 'true';

  // Don't render if auth is disabled or user is not authenticated
  if (!isAuthEnabled || !isAuthenticated) {
    return null;
  }

  const handleLogout = () => {
    logout();
  };

  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      onClick={handleLogout}
      startIcon={<LogoutIcon />}
    >
      Sign Out
    </Button>
  );
};